import { CapacityTableColumn } from "@dto/pageResponse.dto";
import { Table } from "antd";
import { ReactNode } from "react";
import { Plain, XmColumnChild } from "src/component/table/tableTypes";

interface Props<RecordType> {
  data: CapacityTableColumn[];
  cols: XmColumnChild<RecordType> | XmColumnChild<RecordType>[];
}

/**
 * Summary row rendered through the table's own column renderers.
 * @param data summary cells in column order
 * @param cols the table's column elements
 */
export function TableSummary<RecordType>({ data, cols }: Readonly<Props<RecordType>>) {
  const columns = Array.isArray(cols) ? cols : [cols];
  // data rows are records keyed by column order, the summary arrives as a plain array
  const row = Object.fromEntries(data.map((cell, idx) => [idx, cell])) as Plain<RecordType>;
  return (
    <Table.Summary.Row>
      {
        data.map((cell, idx) => {
          // a column definition is not a cell: only its look carries over
          const { className, align, render } = columns[idx].props;
          const rendered = render(cell.value, row, idx);
          // render may return a cell descriptor ({ children, props }), not a node
          const content = rendered && typeof rendered === 'object' && 'children' in rendered ? rendered.children : rendered as ReactNode;
          return (
            <Table.Summary.Cell index={idx} key={idx} className={className} align={align}>{content} </Table.Summary.Cell>
          );
        })
      }
    </Table.Summary.Row>
  );
};
